import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Badge } from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { aulaAuthHeaders } from '../aulaUserContext';
import AulaUserContext from '../aulaUserContext';

const jsonHeaders = () => ({ 'Content-Type': 'application/json;charset=UTF-8', ...aulaAuthHeaders() });

const NuevoCursoForm = ({ onCreado }) => {
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [precio, setPrecio] = useState('');
    const [activo, setActivo] = useState(true);
    const [duracionAccesoDias, setDuracionAccesoDias] = useState('');
    const [imagenUrl, setImagenUrl] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch('/aula/cursos', {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({
                nombre, descripcion, precio: Number(precio), activo, imagenUrl,
                duracionAccesoDias: duracionAccesoDias === '' ? null : Number(duracionAccesoDias)
            })
        }).then((res) => res.json()).then(() => {
            setNombre(''); setDescripcion(''); setPrecio(''); setDuracionAccesoDias(''); setImagenUrl('');
            onCreado();
        });
    };

    return (
        <form className="form-inline mb-4" onSubmit={handleSubmit}>
            <input className="form-control mr-2 mb-2" placeholder="Nombre del curso" value={nombre}
                onChange={(e) => setNombre(e.target.value)} required />
            <input className="form-control mr-2 mb-2" placeholder="Descripción" value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)} />
            <input className="form-control mr-2 mb-2" type="number" placeholder="Precio" value={precio}
                onChange={(e) => setPrecio(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="number" placeholder="Acceso (días, vacío = sin límite)"
                value={duracionAccesoDias} onChange={(e) => setDuracionAccesoDias(e.target.value)} style={{ width: '260px' }} />
            <input className="form-control mr-2 mb-2" placeholder="URL de imagen de portada (opcional)"
                value={imagenUrl} onChange={(e) => setImagenUrl(e.target.value)} style={{ width: '280px' }} />
            <label className="mr-2 mb-2">
                <input type="checkbox" checked={activo} onChange={(e) => setActivo(e.target.checked)} /> Activo
            </label>
            <button className="btn aula-btn-primary mb-2" type="submit">Crear curso</button>
        </form>
    );
};

const EditarCursoForm = ({ curso, onGuardado, onCancelar }) => {
    const [nombre, setNombre] = useState(curso.nombre);
    const [descripcion, setDescripcion] = useState(curso.descripcion || '');
    const [precio, setPrecio] = useState(curso.precio);
    const [activo, setActivo] = useState(curso.activo);
    const [duracionAccesoDias, setDuracionAccesoDias] = useState(curso.duracionAccesoDias ?? '');
    const [imagenUrl, setImagenUrl] = useState(curso.imagenUrl || '');

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(`/aula/cursos/${curso.id}`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({
                nombre, descripcion, precio: Number(precio), activo, imagenUrl,
                duracionAccesoDias: duracionAccesoDias === '' ? null : Number(duracionAccesoDias)
            })
        }).then(() => onGuardado());
    };

    return (
        <form className="form-inline mb-3 p-2" style={{ background: '#f5f8fc', borderRadius: '8px' }} onSubmit={handleSubmit}>
            <input className="form-control mr-2 mb-2" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
            <input className="form-control mr-2 mb-2" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
            <input className="form-control mr-2 mb-2" type="number" value={precio} onChange={(e) => setPrecio(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="number" placeholder="Acceso (días)" value={duracionAccesoDias}
                onChange={(e) => setDuracionAccesoDias(e.target.value)} style={{ width: '150px' }} />
            <input className="form-control mr-2 mb-2" placeholder="URL de imagen de portada"
                value={imagenUrl} onChange={(e) => setImagenUrl(e.target.value)} style={{ width: '260px' }} />
            <label className="mr-2 mb-2">
                <input type="checkbox" checked={activo} onChange={(e) => setActivo(e.target.checked)} /> Activo
            </label>
            <button className="btn aula-btn-primary btn-sm mb-2 mr-2" type="submit">Guardar</button>
            <button className="btn btn-outline-secondary btn-sm mb-2" type="button" onClick={onCancelar}>Cancelar</button>
        </form>
    );
};

// Editor común para alta/edición de módulo: título, video, y listas dinámicas
// de bloques de texto y recursos descargables.
const ModuloForm = ({ inicial, onGuardar, onCancelar, textoBoton }) => {
    const [titulo, setTitulo] = useState(inicial.titulo || '');
    const [videos, setVideos] = useState(
        inicial.videos && inicial.videos.length > 0
            ? inicial.videos.map((v) => ({ titulo: v.titulo || '', url: v.url }))
            : [{ titulo: '', url: '' }]
    );
    const [bloques, setBloques] = useState(
        inicial.bloques && inicial.bloques.length > 0 ? inicial.bloques.map((b) => b.texto) : ['']
    );
    const [recursos, setRecursos] = useState(
        inicial.recursos && inicial.recursos.length > 0
            ? inicial.recursos.map((r) => ({ titulo: r.titulo || '', url: r.url }))
            : []
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        onGuardar({
            titulo,
            videos: videos.filter((v) => v.url.trim() !== ''),
            bloques: bloques.filter((b) => b.trim() !== ''),
            recursos: recursos.filter((r) => r.url.trim() !== '')
        });
    };

    return (
        <form className="p-2" style={{ background: '#f5f8fc', borderRadius: '8px' }} onSubmit={handleSubmit}>
            <div className="form-group">
                <label>Título del módulo</label>
                <input className="form-control" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />
            </div>

            <label>Videos (link de YouTube, Vimeo o URL directa — se pueden agregar varios)</label>
            {videos.map((video, idx) => (
                <div className="form-inline mb-1" key={idx}>
                    <input className="form-control mr-2 mb-1" placeholder="Título (opcional, ej: Parte 1)" value={video.titulo}
                        onChange={(e) => setVideos(videos.map((v, i) => i === idx ? { ...v, titulo: e.target.value } : v))} />
                    <input className="form-control mr-2 mb-1" placeholder="URL del video" value={video.url}
                        style={{ width: '280px' }}
                        onChange={(e) => setVideos(videos.map((v, i) => i === idx ? { ...v, url: e.target.value } : v))} />
                    <button type="button" className="btn btn-sm btn-outline-danger mb-1"
                        onClick={() => setVideos(videos.filter((_, i) => i !== idx))}>×</button>
                </div>
            ))}
            <button type="button" className="btn btn-sm aula-btn-outline mb-2"
                onClick={() => setVideos([...videos, { titulo: '', url: '' }])}>
                + Agregar video
            </button>

            <label className="d-block mt-2">Bloques de texto</label>
            {bloques.map((texto, idx) => (
                <div className="d-flex mb-1" key={idx}>
                    <textarea className="form-control mr-2" rows={2} value={texto}
                        onChange={(e) => setBloques(bloques.map((b, i) => i === idx ? e.target.value : b))} />
                    <button type="button" className="btn btn-sm btn-outline-danger"
                        onClick={() => setBloques(bloques.filter((_, i) => i !== idx))}>×</button>
                </div>
            ))}
            <button type="button" className="btn btn-sm aula-btn-outline mb-2" onClick={() => setBloques([...bloques, ''])}>
                + Agregar bloque de texto
            </button>

            <label className="d-block mt-2">Recursos descargables (PDF/PPT)</label>
            {recursos.map((recurso, idx) => (
                <div className="form-inline mb-1" key={idx}>
                    <input className="form-control mr-2 mb-1" placeholder="Título" value={recurso.titulo}
                        onChange={(e) => setRecursos(recursos.map((r, i) => i === idx ? { ...r, titulo: e.target.value } : r))} />
                    <input className="form-control mr-2 mb-1" placeholder="URL" value={recurso.url}
                        onChange={(e) => setRecursos(recursos.map((r, i) => i === idx ? { ...r, url: e.target.value } : r))} />
                    <button type="button" className="btn btn-sm btn-outline-danger mb-1"
                        onClick={() => setRecursos(recursos.filter((_, i) => i !== idx))}>×</button>
                </div>
            ))}
            <button type="button" className="btn btn-sm aula-btn-outline mb-2"
                onClick={() => setRecursos([...recursos, { titulo: '', url: '' }])}>
                + Agregar recurso
            </button>

            <div className="mt-2">
                <button className="btn aula-btn-primary btn-sm mr-2" type="submit">{textoBoton}</button>
                {onCancelar && <button className="btn btn-outline-secondary btn-sm" type="button" onClick={onCancelar}>Cancelar</button>}
            </div>
        </form>
    );
};

const NuevoAlumnoForm = ({ onCreado }) => {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(''); setMensaje('');
        fetch('/aula/auth/admin-crear-alumno', {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ nombre, email, contrasena })
        }).then(async (res) => {
            if (res.status === 200) {
                setMensaje(`Cuenta creada para ${email}.`);
                setNombre(''); setEmail(''); setContrasena('');
                onCreado();
            } else {
                setError('No se pudo crear la cuenta (¿el email ya existe?).');
            }
        });
    };

    return (
        <form className="form-inline mb-2" onSubmit={handleSubmit}>
            <input className="form-control mr-2 mb-2" placeholder="Nombre del alumno" value={nombre}
                onChange={(e) => setNombre(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="email" placeholder="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="text" placeholder="Contraseña temporal" value={contrasena}
                onChange={(e) => setContrasena(e.target.value)} required minLength={8} />
            <button className="btn aula-btn-primary mb-2" type="submit">Crear cuenta</button>
            {mensaje && <span className="d-block text-success">{mensaje}</span>}
            {error && <span className="d-block text-danger">{error}</span>}
        </form>
    );
};

const NuevoStaffForm = ({ onCreado }) => {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [rol, setRol] = useState('Supervisor');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(''); setMensaje('');
        fetch('/aula/auth/admin-crear-staff', {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ nombre, email, contrasena, rol })
        }).then(async (res) => {
            if (res.status === 200) {
                setMensaje(`Cuenta de ${rol.toLowerCase()} creada para ${email}.`);
                setNombre(''); setEmail(''); setContrasena('');
                onCreado();
            } else {
                setError('No se pudo crear la cuenta (¿el email ya existe?).');
            }
        });
    };

    return (
        <form className="form-inline mb-2" onSubmit={handleSubmit}>
            <input className="form-control mr-2 mb-2" placeholder="Nombre" value={nombre}
                onChange={(e) => setNombre(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="email" placeholder="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="text" placeholder="Contraseña temporal" value={contrasena}
                onChange={(e) => setContrasena(e.target.value)} required minLength={8} />
            <select className="form-control mr-2 mb-2" value={rol} onChange={(e) => setRol(e.target.value)}>
                <option value="Supervisor">Supervisor (solo aprueba inscripciones)</option>
                <option value="Admin">Admin (acceso completo)</option>
            </select>
            <button className="btn aula-btn-primary mb-2" type="submit">Crear cuenta</button>
            {mensaje && <span className="d-block text-success">{mensaje}</span>}
            {error && <span className="d-block text-danger">{error}</span>}
        </form>
    );
};

const EditarAlumnoForm = ({ alumno, onGuardado }) => {
    const [nombre, setNombre] = useState(alumno.nombre);
    const [email, setEmail] = useState(alumno.email);
    const [nuevaContrasena, setNuevaContrasena] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(''); setMensaje('');
        fetch(`/aula/auth/alumnos/${alumno.id}`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({ nombre, email, nuevaContrasena: nuevaContrasena || null })
        }).then(async (res) => {
            if (res.status === 200) {
                setMensaje('Datos actualizados.');
                setNuevaContrasena('');
                onGuardado();
            } else {
                setError('No se pudo actualizar (¿el email ya está en uso?).');
            }
        });
    };

    return (
        <form className="form-inline mb-2" onSubmit={handleSubmit}>
            <input className="form-control mr-2 mb-2" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
            <input className="form-control mr-2 mb-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input className="form-control mr-2 mb-2" placeholder="Nueva contraseña (opcional)" value={nuevaContrasena}
                onChange={(e) => setNuevaContrasena(e.target.value)} />
            <button className="btn aula-btn-primary btn-sm mb-2" type="submit">Guardar</button>
            {mensaje && <span className="d-block text-success">{mensaje}</span>}
            {error && <span className="d-block text-danger">{error}</span>}
        </form>
    );
};

const AsignarCursoForm = ({ alumno, cursos, onAsignado }) => {
    const [cursoId, setCursoId] = useState(cursos[0]?.id || '');
    const [mensaje, setMensaje] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch('/aula/inscripciones/admin-asignar', {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ usuarioAulaId: alumno.id, cursoId: Number(cursoId) })
        }).then(() => {
            setMensaje('Curso asignado, acceso activo.');
            onAsignado();
        });
    };

    if (cursos.length === 0) return null;

    return (
        <form className="form-inline mb-2" onSubmit={handleSubmit}>
            <select className="form-control mr-2 mb-2" value={cursoId} onChange={(e) => setCursoId(e.target.value)}>
                {cursos.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
            </select>
            <button className="btn aula-btn-outline btn-sm mb-2" type="submit">Asignar curso (acceso inmediato)</button>
            {mensaje && <span className="d-block text-success">{mensaje}</span>}
        </form>
    );
};

const BuscadorAlumnos = ({ cursos }) => {
    const [q, setQ] = useState('');
    const [resultados, setResultados] = useState([]);
    const [seleccionado, setSeleccionado] = useState(null);
    const [historial, setHistorial] = useState([]);

    const buscar = useCallback(() => {
        fetch(`/aula/auth/alumnos?q=${encodeURIComponent(q)}`, { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setResultados);
    }, [q]);

    useEffect(() => { buscar(); }, [buscar]);

    const cargarHistorial = useCallback((id) => {
        fetch(`/aula/inscripciones/alumno/${id}`, { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setHistorial);
    }, []);

    const seleccionar = (alumno) => {
        setSeleccionado(alumno);
        cargarHistorial(alumno.id);
    };

    const handleCambiarRol = (alumno, nuevoRol) => {
        if (nuevoRol === alumno.rol) return;
        if (!window.confirm(`¿Cambiar el rol de ${alumno.nombre} a "${nuevoRol}"?`)) return;

        fetch(`/aula/auth/usuarios/${alumno.id}/rol`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({ rol: nuevoRol })
        }).then(async (res) => {
            if (res.status === 200) {
                const data = await res.json();
                setSeleccionado(data);
                buscar();
            } else {
                window.alert('No se pudo cambiar el rol (¿es el único admin?).');
            }
        });
    };

    const handleEliminar = (alumno) => {
        if (!window.confirm(`¿Eliminar la cuenta de ${alumno.nombre} (${alumno.email})? Esto borra también sus inscripciones y progreso. No se puede deshacer.`)) return;

        fetch(`/aula/auth/usuarios/${alumno.id}`, { method: 'DELETE', headers: aulaAuthHeaders() })
            .then(async (res) => {
                if (res.status === 200) {
                    setSeleccionado(null);
                    buscar();
                } else {
                    window.alert('No se pudo eliminar (¿es el único admin, o sos vos mismo?).');
                }
            });
    };

    return (
        <div>
            <form className="form-inline mb-2" onSubmit={(e) => { e.preventDefault(); buscar(); }}>
                <input className="form-control mr-2 mb-2" placeholder="Buscar alumno por nombre o email"
                    value={q} onChange={(e) => setQ(e.target.value)} style={{ width: '300px' }} />
                <button className="btn aula-btn-outline mb-2" type="submit">Buscar</button>
            </form>

            <ul className="list-group mb-3">
                {resultados.map((a) => (
                    <li className={`list-group-item ${seleccionado && seleccionado.id === a.id ? 'aula-modulo-list-item completado' : ''}`}
                        key={a.id} style={{ cursor: 'pointer' }} onClick={() => seleccionar(a)}>
                        {a.nombre} ({a.email}) {a.rol !== 'Alumno' && <Badge color="info">{a.rol}</Badge>}
                    </li>
                ))}
            </ul>

            {seleccionado &&
                // key=id fuerza a React a recrear este bloque (y el estado interno de sus
                // forms) cuando se selecciona otro alumno — si no, los inputs se quedaban
                // mostrando los datos del alumno anterior.
                <div className="card aula-card p-3" key={seleccionado.id}>
                    <div className="d-flex justify-content-between align-items-start">
                        <h6>Editar datos de {seleccionado.nombre}</h6>
                        {seleccionado.rol !== 'Alumno' && <Badge color="info">{seleccionado.rol}</Badge>}
                    </div>
                    <EditarAlumnoForm alumno={seleccionado} onGuardado={() => buscar()} />

                    <div className="mb-3 form-inline">
                        <label className="mr-2">Rol:</label>
                        <select className="form-control mr-2" value={seleccionado.rol}
                            onChange={(e) => handleCambiarRol(seleccionado, e.target.value)}>
                            <option value="Alumno">Alumno</option>
                            <option value="Supervisor">Supervisor</option>
                            <option value="Admin">Admin</option>
                        </select>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleEliminar(seleccionado)}>
                            Eliminar cuenta
                        </button>
                    </div>

                    <hr />
                    <h6>Asignar curso directamente</h6>
                    <AsignarCursoForm alumno={seleccionado} cursos={cursos} onAsignado={() => cargarHistorial(seleccionado.id)} />

                    <hr />
                    <h6>Historial de inscripciones</h6>
                    {historial.length === 0 && <p>Sin inscripciones.</p>}
                    <ul className="list-group">
                        {historial.map((i) => (
                            <li className="list-group-item" key={i.id}>
                                {i.curso?.nombre} — {i.estado}
                                {i.fechaVencimiento && ` — vence ${new Date(i.fechaVencimiento).toLocaleDateString()}`}
                            </li>
                        ))}
                    </ul>
                </div>}
        </div>
    );
};

const ConfiguracionPagoForm = () => {
    const [pago, setPago] = useState(null);
    const [mensaje, setMensaje] = useState('');

    useEffect(() => {
        fetch('/aula/configuracion/pago', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setPago);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setMensaje('');
        fetch('/aula/configuracion/pago', {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify(pago)
        }).then(() => setMensaje('Datos de pago actualizados.'));
    };

    if (!pago) return <p>Cargando...</p>;

    return (
        <form onSubmit={handleSubmit}>
            <p className="text-muted">Estos datos aparecen en el mail que recibe el alumno al solicitar un curso.</p>
            <div className="form-group">
                <label>Alias</label>
                <input className="form-control" value={pago.alias} onChange={(e) => setPago({ ...pago, alias: e.target.value })} />
            </div>
            <div className="form-group">
                <label>CBU</label>
                <input className="form-control" value={pago.cbu} onChange={(e) => setPago({ ...pago, cbu: e.target.value })} />
            </div>
            <div className="form-group">
                <label>Titular</label>
                <input className="form-control" value={pago.titular} onChange={(e) => setPago({ ...pago, titular: e.target.value })} />
            </div>
            <div className="form-group">
                <label>Instrucciones adicionales</label>
                <textarea className="form-control" rows={2} value={pago.instrucciones}
                    onChange={(e) => setPago({ ...pago, instrucciones: e.target.value })} />
            </div>
            <button className="btn aula-btn-primary btn-sm" type="submit">Guardar</button>
            {mensaje && <span className="d-block text-success mt-2">{mensaje}</span>}
        </form>
    );
};

const NotificacionesForm = () => {
    const [destinatarios, setDestinatarios] = useState([]);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const cargar = useCallback(() => {
        fetch('/aula/configuracion/notificaciones', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setDestinatarios);
    }, []);

    useEffect(() => { cargar(); }, [cargar]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        fetch('/aula/configuracion/notificaciones', {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ email })
        }).then(async (res) => {
            if (res.status === 200) {
                setEmail('');
                cargar();
            } else {
                setError(await res.text());
            }
        });
    };

    const handleEliminar = (id) => {
        fetch(`/aula/configuracion/notificaciones/${id}`, { method: 'DELETE', headers: aulaAuthHeaders() })
            .then(() => cargar());
    };

    return (
        <div>
            <p className="text-muted">
                Estos emails reciben un aviso cada vez que alguien solicita un curso (con un link para
                revisarlo y aprobarlo desde el panel). No hace falta que tengan cuenta de admin/supervisor.
            </p>
            <form className="form-inline mb-2" onSubmit={handleSubmit}>
                <input className="form-control mr-2 mb-2" type="email" placeholder="Email a notificar"
                    value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '280px' }} />
                <button className="btn aula-btn-primary mb-2" type="submit">Agregar</button>
            </form>
            {error && <p className="text-danger">{error}</p>}
            <ul className="list-group" style={{ maxWidth: '400px' }}>
                {destinatarios.map((d) => (
                    <li className="list-group-item d-flex justify-content-between align-items-center" key={d.id}>
                        {d.email}
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleEliminar(d.id)}>×</button>
                    </li>
                ))}
                {destinatarios.length === 0 && <li className="list-group-item text-muted">Nadie configurado todavía.</li>}
            </ul>
        </div>
    );
};

const PLACEHOLDERS_POR_PLANTILLA = {
    Confirmacion: '{nombre}, {codigo}, {minutos}',
    DatosPago: '{nombre}, {curso}, {precio}, {alias}, {cbu}, {titular}, {instrucciones}',
    AccesoHabilitado: '{nombre}, {curso}'
};

const NOMBRE_PLANTILLA = {
    Confirmacion: 'Confirmación de cuenta (código de 6 dígitos)',
    DatosPago: 'Datos de pago (al solicitar un curso)',
    AccesoHabilitado: 'Acceso habilitado (al aprobar el pago)'
};

const EmailTemplateForm = ({ template, onGuardado }) => {
    const [asunto, setAsunto] = useState(template.asunto);
    const [cuerpo, setCuerpo] = useState(template.cuerpo);
    const [mensaje, setMensaje] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setMensaje('');
        fetch(`/aula/configuracion/email-templates/${template.clave}`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({ asunto, cuerpo })
        }).then(() => { setMensaje('Guardado.'); onGuardado(); });
    };

    return (
        <form className="card aula-card p-3 mb-3" onSubmit={handleSubmit}>
            <h6>{NOMBRE_PLANTILLA[template.clave] || template.clave}</h6>
            <p className="text-muted">Placeholders disponibles: {PLACEHOLDERS_POR_PLANTILLA[template.clave]}</p>
            <div className="form-group">
                <label>Asunto</label>
                <input className="form-control" value={asunto} onChange={(e) => setAsunto(e.target.value)} required />
            </div>
            <div className="form-group">
                <label>Cuerpo (HTML)</label>
                <textarea className="form-control" rows={5} value={cuerpo} onChange={(e) => setCuerpo(e.target.value)} required />
            </div>
            <button className="btn aula-btn-primary btn-sm" type="submit" style={{ width: 'fit-content' }}>Guardar plantilla</button>
            {mensaje && <span className="d-block text-success mt-2">{mensaje}</span>}
        </form>
    );
};

const EmailTemplatesForm = () => {
    const [templates, setTemplates] = useState([]);

    const cargar = useCallback(() => {
        fetch('/aula/configuracion/email-templates', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setTemplates);
    }, []);

    useEffect(() => { cargar(); }, [cargar]);

    return (
        <div>
            {templates.map((t) => (
                <EmailTemplateForm key={t.clave} template={t} onGuardado={cargar} />
            ))}
        </div>
    );
};

const AdminPanel = () => {
    const { aulaAuth } = useContext(AulaUserContext);
    const esSupervisor = aulaAuth.rol === 'Supervisor';

    const paramsIniciales = new URLSearchParams(window.location.search);
    const tabInicial = paramsIniciales.get('tab');
    const inscripcionInicial = paramsIniciales.get('inscripcion');

    const [tab, setTab] = useState(esSupervisor ? 'pendientes' : (tabInicial || 'cursos'));
    const [cursos, setCursos] = useState([]);
    const [pendientes, setPendientes] = useState([]);
    const [activas, setActivas] = useState([]);
    const [cursoEnEdicion, setCursoEnEdicion] = useState(null);
    const [moduloEnEdicion, setModuloEnEdicion] = useState(null);
    const [agregandoModuloEn, setAgregandoModuloEn] = useState(null);
    const [filtroPendientes, setFiltroPendientes] = useState('');
    const [filtroActivas, setFiltroActivas] = useState('');
    const [inscripcionDestacada] = useState(inscripcionInicial ? Number(inscripcionInicial) : null);

    const cargarCursos = useCallback(() => {
        fetch('/aula/cursos/admin/todos', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setCursos);
    }, []);

    const cargarPendientes = useCallback(() => {
        fetch('/aula/inscripciones/pendientes', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setPendientes);
    }, []);

    const cargarActivas = useCallback(() => {
        fetch('/aula/inscripciones/activas', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setActivas);
    }, []);

    useEffect(() => { cargarCursos(); cargarPendientes(); cargarActivas(); }, [cargarCursos, cargarPendientes, cargarActivas]);

    const verComprobante = (id) => {
        fetch(`/aula/inscripciones/${id}/comprobante`, { headers: aulaAuthHeaders() })
            .then((res) => res.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
            });
    };

    const handleHabilitar = (id) => {
        fetch(`/aula/inscripciones/${id}/habilitar`, { method: 'PUT', headers: aulaAuthHeaders() })
            .then(() => { cargarPendientes(); cargarActivas(); });
    };

    const handleRechazar = (id, nombre) => {
        if (!window.confirm(`¿Descartar la solicitud de ${nombre}? No se le va a habilitar el acceso.`)) return;
        fetch(`/aula/inscripciones/${id}/rechazar`, { method: 'DELETE', headers: aulaAuthHeaders() })
            .then(() => cargarPendientes());
    };

    const handleDarDeBaja = (id, nombre) => {
        if (!window.confirm(`¿Dar de baja el acceso de ${nombre}? Va a dejar de poder ver el curso.`)) return;
        fetch(`/aula/inscripciones/${id}/dar-de-baja`, { method: 'PUT', headers: aulaAuthHeaders() })
            .then(() => cargarActivas());
    };

    const crearModulo = (cursoId, siguienteOrden, datos) => {
        fetch(`/aula/cursos/${cursoId}/modulos`, {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ ...datos, orden: siguienteOrden })
        }).then(() => { setAgregandoModuloEn(null); cargarCursos(); });
    };

    const editarModulo = (moduloId, orden, datos) => {
        fetch(`/aula/cursos/modulos/${moduloId}`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({ ...datos, orden })
        }).then(() => { setModuloEnEdicion(null); cargarCursos(); });
    };

    const handleDragEnd = (cursoId, modulos) => (result) => {
        if (!result.destination) return;
        const reordenados = Array.from(modulos);
        const [movido] = reordenados.splice(result.source.index, 1);
        reordenados.splice(result.destination.index, 0, movido);

        const orden = reordenados.map((m, idx) => ({ id: m.id, orden: idx + 1 }));
        fetch(`/aula/cursos/${cursoId}/modulos/orden`, {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify(orden)
        }).then(() => cargarCursos());
    };

    const pendientesFiltrados = pendientes.filter((i) => {
        const texto = filtroPendientes.toLowerCase();
        return !texto || i.usuario.nombre.toLowerCase().includes(texto) || i.usuario.email.toLowerCase().includes(texto);
    });

    const activasFiltradas = activas.filter((i) => {
        const texto = filtroActivas.toLowerCase();
        return !texto || i.usuario.nombre.toLowerCase().includes(texto) || i.usuario.email.toLowerCase().includes(texto);
    });

    return (
        <div className="container my-4">
            <h3 className="title">Panel admin — Aula Virtual</h3>

            <Nav tabs className="aula-admin-tabs mt-4">
                {!esSupervisor &&
                    <NavItem>
                        <NavLink href="#" active={tab === 'cursos'} onClick={() => setTab('cursos')}>
                            Cursos
                        </NavLink>
                    </NavItem>}
                <NavItem>
                    <NavLink href="#" active={tab === 'pendientes'} onClick={() => setTab('pendientes')}>
                        Inscripciones pendientes
                        {pendientes.length > 0 && <Badge color="danger" pill className="ml-2">{pendientes.length}</Badge>}
                    </NavLink>
                </NavItem>
                {!esSupervisor &&
                    <NavItem>
                        <NavLink href="#" active={tab === 'alumnos'} onClick={() => setTab('alumnos')}>
                            Alumnos y accesos
                        </NavLink>
                    </NavItem>}
                {!esSupervisor &&
                    <NavItem>
                        <NavLink href="#" active={tab === 'configuracion'} onClick={() => setTab('configuracion')}>
                            Configuración
                        </NavLink>
                    </NavItem>}
            </Nav>

            <TabContent activeTab={tab} className="p-3 aula-admin-tab-content">
                <TabPane tabId="cursos">
                    <NuevoCursoForm onCreado={cargarCursos} />

                    {cursos.map((curso) => (
                        <div className="card aula-card p-3 mb-3" key={curso.id}>
                            {cursoEnEdicion === curso.id ? (
                                <EditarCursoForm
                                    curso={curso}
                                    onGuardado={() => { setCursoEnEdicion(null); cargarCursos(); }}
                                    onCancelar={() => setCursoEnEdicion(null)}
                                />
                            ) : (
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6>
                                        {curso.nombre} — ${curso.precio} {curso.activo ? '' : '(inactivo)'}
                                        {curso.duracionAccesoDias
                                            ? ` — acceso por ${curso.duracionAccesoDias} días`
                                            : ' — acceso sin límite'}
                                    </h6>
                                    <button className="btn btn-sm aula-btn-outline" onClick={() => setCursoEnEdicion(curso.id)}>Editar curso</button>
                                </div>
                            )}

                            <DragDropContext onDragEnd={handleDragEnd(curso.id, curso.modulos)}>
                                <Droppable droppableId={`modulos-${curso.id}`}>
                                    {(provided) => (
                                        <ul className="list-group mb-2 mt-2" ref={provided.innerRef} {...provided.droppableProps}>
                                            {curso.modulos.map((m, index) => (
                                                <Draggable key={m.id} draggableId={String(m.id)} index={index}>
                                                    {(providedDrag) => (
                                                        <li className="list-group-item" ref={providedDrag.innerRef}
                                                            {...providedDrag.draggableProps}>
                                                            {moduloEnEdicion === m.id ? (
                                                                <ModuloForm
                                                                    inicial={m}
                                                                    textoBoton="Guardar"
                                                                    onGuardar={(datos) => editarModulo(m.id, m.orden, datos)}
                                                                    onCancelar={() => setModuloEnEdicion(null)}
                                                                />
                                                            ) : (
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span {...providedDrag.dragHandleProps}>
                                                                        ⠿ {m.orden}. {m.titulo}
                                                                    </span>
                                                                    <button className="btn btn-sm aula-btn-outline"
                                                                        onClick={() => setModuloEnEdicion(m.id)}>Editar</button>
                                                                </div>
                                                            )}
                                                        </li>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </ul>
                                    )}
                                </Droppable>
                            </DragDropContext>

                            {agregandoModuloEn === curso.id ? (
                                <ModuloForm
                                    inicial={{}}
                                    textoBoton="Agregar módulo"
                                    onGuardar={(datos) => crearModulo(curso.id, curso.modulos.length + 1, datos)}
                                    onCancelar={() => setAgregandoModuloEn(null)}
                                />
                            ) : (
                                <button className="btn aula-btn-outline btn-sm mt-2" onClick={() => setAgregandoModuloEn(curso.id)}>
                                    + Agregar módulo
                                </button>
                            )}
                        </div>
                    ))}
                </TabPane>

                <TabPane tabId="pendientes">
                    <input className="form-control mb-3" placeholder="Buscar por nombre o email"
                        value={filtroPendientes} onChange={(e) => setFiltroPendientes(e.target.value)} style={{ maxWidth: '320px' }} />
                    {pendientesFiltrados.length === 0 && <p>No hay inscripciones pendientes.</p>}
                    <ul className="list-group mb-2">
                        {pendientesFiltrados.map((i) => (
                            <li className={`list-group-item d-flex justify-content-between align-items-center ${i.id === inscripcionDestacada ? 'aula-modulo-list-item completado' : ''}`}
                                key={i.id} ref={i.id === inscripcionDestacada ? (el) => el && el.scrollIntoView({ block: 'center' }) : null}>
                                <span>
                                    <span className="d-block">
                                        {i.usuario.nombre} ({i.usuario.email}) — {i.curso.nombre}
                                        {i.comprobanteUrl &&
                                            <button type="button" className="btn btn-link btn-sm p-0 ml-2"
                                                onClick={() => verComprobante(i.id)}>
                                                Ver comprobante
                                            </button>}
                                    </span>
                                    <small className="d-block aula-datos-facturacion-linea">
                                        Facturar a: DNI/CUIT/CUIL {i.cuit} — {i.condicionIva}
                                        {i.razonSocial && ` — ${i.razonSocial}`}
                                        {i.domicilioFiscal && ` — ${i.domicilioFiscal}`}
                                    </small>
                                </span>
                                <span>
                                    <button className="btn btn-sm btn-success mr-2" onClick={() => handleHabilitar(i.id)}>
                                        Habilitar (pago verificado)
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleRechazar(i.id, i.usuario.nombre)}>
                                        Rechazar
                                    </button>
                                </span>
                            </li>
                        ))}
                    </ul>
                </TabPane>

                <TabPane tabId="alumnos">
                    <section className="aula-config-section">
                        <h5>Crear cuenta de alumno</h5>
                        <NuevoAlumnoForm onCreado={cargarPendientes} />
                    </section>

                    <section className="aula-config-section">
                        <h5>Crear cuenta de admin o supervisor</h5>
                        <NuevoStaffForm onCreado={() => {}} />
                    </section>

                    <section className="aula-config-section">
                        <h5>Buscar / editar alumno</h5>
                        <BuscadorAlumnos cursos={cursos} />
                    </section>

                    <section className="aula-config-section">
                        <h5>Accesos activos</h5>
                        <input className="form-control mb-3" placeholder="Buscar por nombre o email"
                            value={filtroActivas} onChange={(e) => setFiltroActivas(e.target.value)} style={{ maxWidth: '320px' }} />
                        {activasFiltradas.length === 0 && <p>No hay accesos activos.</p>}
                        <ul className="list-group mb-2">
                            {activasFiltradas.map((i) => (
                                <li className="list-group-item d-flex justify-content-between align-items-center" key={i.id}>
                                    <span>
                                        <span className="d-block">
                                            {i.usuario.nombre} ({i.usuario.email}) — {i.curso.nombre}
                                            {i.fechaVencimiento && (
                                                <> — vence {new Date(i.fechaVencimiento).toLocaleDateString()}{!i.vigente ? ' (vencido)' : ''}</>
                                            )}
                                        </span>
                                        {i.cuit &&
                                            <small className="d-block aula-datos-facturacion-linea">
                                                Facturar a: DNI/CUIT/CUIL {i.cuit} — {i.condicionIva}
                                                {i.razonSocial && ` — ${i.razonSocial}`}
                                                {i.domicilioFiscal && ` — ${i.domicilioFiscal}`}
                                            </small>}
                                    </span>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDarDeBaja(i.id, i.usuario.nombre)}>
                                        Dar de baja
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </section>
                </TabPane>

                <TabPane tabId="configuracion">
                    <section className="aula-config-section">
                        <h5>Datos de pago</h5>
                        <ConfiguracionPagoForm />
                    </section>

                    <section className="aula-config-section">
                        <h5>Plantillas de email</h5>
                        <EmailTemplatesForm />
                    </section>

                    <section className="aula-config-section">
                        <h5>Notificaciones de nuevas solicitudes</h5>
                        <NotificacionesForm />
                    </section>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default AdminPanel;
